import { AxiosResponse } from 'axios';
import { extractOob as fn } from '../../BffClient/extractors/extractOob';

export const extractOob = ({ data }: AxiosResponse<ReturnType<typeof fn>>) =>
  data;
